import React, { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import RestaurantDetailsTabs from '../../components/RestaurantDetailsTabs/RestaurantDetailsTabs';
import { getEntity as getRestaurant } from '../../redux/actions/restaurantsActions';
import { isEmptyObject } from '../../utils/utils';

type IRDProps = {
  id: string;
  tab: string;
};

function RestaurantDetails(props: any) {
  const { id, tab } = useParams<IRDProps>();
  const dispatch: any = useDispatch();
  const history = useHistory();
  const { selectedBrand } = useSelector(
    (state: RootStateOrAny) => state.UIReducer,
  );
  const selectedRestaurant = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );
  const loadRestaurant = useCallback(async () => {
    const result: any = await dispatch(getRestaurant(id));
    if (!result || result.status !== 200 || isEmptyObject(result.data)) {
      history.goBack();
    }
  }, [dispatch, history, id]);
  useEffect(() => {
    if (id === 'undefined') {
      history.goBack();
    } else {
      loadRestaurant();
    }
  }, [loadRestaurant]);

  useEffect(() => {
    if (Object.keys(selectedRestaurant).length > 0) {
      if (selectedRestaurant.brand !== selectedBrand) {
        history.push('/');
      }
    }
  }, [selectedBrand, history, selectedRestaurant]);
  return (
    <div>
      <RestaurantDetailsTabs id={id} tab={tab} />
    </div>
  );
}

export default RestaurantDetails;
